import './Banner.less';

function Banner({ imageSrc, height="480px", titeSize="48", title, subtitle }) {
  return (
    <div className="banner" style={{ 
    backgroundImage: `url(${imageSrc})`, 
    height: height}}>
        <div className="banner-content">
          <h1 style={{ fontSize: `${titeSize}px` }}>{title}</h1>
          <div>{subtitle}</div>
        </div>
    </div>
  );
}

export default Banner;